import { DestinationParams, DestinationParamsState } from '@anm/api/modules/stream';
import getDestinationsParams from '@anm/helpers/stream/getDestinationParams';
import isEqual from 'lodash/fp/isEqual';
import isNil from 'lodash/isNil';

import { CompareDataProps } from '../types';

export const getIsSameData = ({
  name,
  date,
  preview,
  folderId,
  isWebinar,
  fbGroupIds,
  description,
  isScheduled,
  initialModalState,
  destinationParams,
  canGuestAddDestination,
  selectedDestinationIds
}: CompareDataProps) => {
  const newDestinationParams = Object.keys(destinationParams || {}).reduce((acc, k) => {
    if (!destinationParams) return acc;

    delete destinationParams[k].isHidden;
    acc[k] = destinationParams[k];

    return acc;
  }, {} as DestinationParams);

  const getParams = (destinationParams: DestinationParamsState) => ({
    title: name,
    fbGroupIds,
    description,
    destinationParams,
    preview: preview.src,
    destinationIds: selectedDestinationIds
  });

  const isSameData =
    initialModalState?.title === name &&
    initialModalState.folderId === folderId &&
    initialModalState.description === description &&
    initialModalState.preview === preview.src &&
    !!initialModalState.schedule === isScheduled &&
    !!initialModalState.isWebinar === isWebinar &&
    (!!initialModalState.schedule ? new Date(initialModalState.schedule).getTime() === date : true) &&
    isEqual(selectedDestinationIds.sort(), Object.keys(initialModalState?.destinationParams || {}).sort()) &&
    isEqual(
      getDestinationsParams(getParams(initialModalState?.destinationParams)),
      getDestinationsParams(getParams(newDestinationParams))
    ) &&
    (isNil(canGuestAddDestination) || initialModalState?.canGuestAddDestination === canGuestAddDestination);

  return isSameData;
};
